import { render, staticRenderFns } from "./CertificateCollaboratorsComp.vue?vue&type=template&id=b1afd9f8&scoped=true&"
import script from "./CertificateCollaboratorsComp.vue?vue&type=script&lang=js&"
export * from "./CertificateCollaboratorsComp.vue?vue&type=script&lang=js&"
import style0 from "./CertificateCollaboratorsComp.vue?vue&type=style&index=0&id=b1afd9f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1afd9f8",
  null
  
)

export default component.exports